import { LoaderCircle } from "lucide-react";
import { Navigate, Route, Routes } from "react-router";

import { AppShell } from "@/components/AppShell";
import type { AppUser } from "@/features/board/types";
import { authClient } from "@/lib/auth-client";
import { BoardPage } from "@/pages/BoardPage";
import { ProjectsPage } from "@/pages/ProjectsPage";
import { SignInPage } from "@/pages/SignInPage";
import { SignUpPage } from "@/pages/SignUpPage";

export const App = () => {
  const session = authClient.useSession();
  const user = (session.data?.user as AppUser | undefined) ?? null;

  if (session.isPending) {
    return (
      <main className="grid min-h-dvh place-items-center bg-white">
        <LoaderCircle aria-label="Loading" className="size-4 animate-spin shrink-0 stroke-primary" />
      </main>
    );
  }

  return (
    <AppShell user={user}>
      <Routes>
        <Route path="/" element={<Navigate to={user ? "/projects" : "/sign-in"} replace />} />
        <Route path="/login" element={<Navigate to="/sign-in" replace />} />
        <Route
          path="/sign-in"
          element={user ? <Navigate to="/projects" replace /> : <SignInPage />}
        />
        <Route
          path="/sign-up"
          element={user ? <Navigate to="/projects" replace /> : <SignUpPage />}
        />
        <Route
          path="/projects"
          element={user ? <ProjectsPage /> : <Navigate to="/sign-in" replace />}
        />
        <Route
          path="/projects/:projectId"
          element={user ? <BoardPage user={user} /> : <Navigate to="/sign-in" replace />}
        />
        <Route path="/dashboard" element={<Navigate to={user ? "/projects" : "/sign-in"} replace />} />
        <Route path="*" element={<Navigate to={user ? "/projects" : "/sign-in"} replace />} />
      </Routes>
    </AppShell>
  );
};
